<template>
  <v-select ref="selector" :items="items" item-text="displayname" item-value="proposal_id" v-model="selectedProposalId"
    data-cy=prop-search>
    <template slot="label"><span style="font-size: 12px">Proposal selection</span></template>
  </v-select>
</template>
<script>
import { EventBus } from "../../js/DataManagement/EventBus";
export default {
  name: "ProposalSelectionDropdown",
  props: ["proposals", "side"],
  components: {},
  data: function () {
    return {};
  },
  watch: {
    selectedProposalId: function (selectedId) {
      const proposal = this.proposals.find(proposal => proposal.proposal_id === selectedId)
      if (proposal) this.updateProposal(proposal)
    },
    proposals: {
      handler: function (proposals) {

        if (proposals.length === 0) return

        const proposalIds = proposals.map(d => d.proposal_id);
        const currentProposal = this.$store.getters[`getSide${this.side}Proposal`]

        // check if the is a selection, and if it is valid
        if (currentProposal && proposalIds.includes(currentProposal)) return

        // DEFAULTS FOR PROPOSALS
        // if cong_premiddecade_all then sideA: cong_premiddecade_all (cong_premiddecade) and sideB: cong_new_all (final_2021)
        // otherwise sideA: cong_current_all (current_2012) and sideB: cong_new_all (final_2021)
        const proposalMap = {
          'cong_premiddecade': { A: 'cong_premiddecade', B: 'final_2021' },
          'current_2012': { A: 'current_2012', B: 'final_2021' }
        };

        let selectedProposal = null;

        // Check for specific proposal combinations
        for (const [primaryProposal, sideMap] of Object.entries(proposalMap)) {
          if (proposalIds.includes(primaryProposal) && proposalIds.includes('final_2021')) {
            const proposal_id = sideMap[this.side];
            if (proposal_id) {
              selectedProposal = proposal_id;
              break;
            }
          }
        }

        // Default to first matching proposal
        if (!selectedProposal) {
          const sideIndex = ['A', 'B'];
          const defaultProposal = this.proposals[sideIndex.findIndex(letter => letter === this.side)];
          if (defaultProposal) {
            selectedProposal = defaultProposal.proposal_id;
          }
        }
        if (selectedProposal) {
          this.$store.commit(`setSide${this.side}Proposal`, selectedProposal);
        }
      },
    }
  },
  destroyed() {
    // reset state
    const sideIndex = ['A', 'B']
    const defaultProposal = this.proposals[sideIndex.findIndex(letter => letter === this.side)]
    this.updateProposal(defaultProposal)
  },
  methods: {
    updateProposal(proposal) {
      const { tablename, displayname, proposal_id } = proposal
      // set side info 
      this.$store.commit(`setSide${this.side}id`, tablename)
      this.$store.commit(
        `setSide${this.side}Proposal`,
        proposal_id
      );
      this.$store.commit(
        `setSide${this.side}DisplayName`,
        displayname
      );
      // set layer
      this.$layerManager.showProposal({
        _id: tablename,
        _side: this.side,
      });
      // set url
      this.$querystringManager.addQueryParam(
        `prop${this.side}`,
        proposal_id
      );

      EventBus.$emit(`update-side-panel-${this.side}-proposal`)
    }
  },
  computed: {
    items: function () {
      return this.proposals
    },
    selectedProposalId: {
      get() {
        return this.$store.getters[`getSide${this.side}Proposal`]
      },
      set(value) {
        this.$store.commit(`setSide${this.side}Proposal`, value)
      }
    }
  },
};
</script>